import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";

export class DayForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: props.day,
            dateInputError: null,
            dayTypeInputError: null,
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { day } = this.state;

        day[property] = e.target.value;

        this.setState({
            day: day
        });
    }

    onChangeDateValue(e, property) {
        const { day } = this.state;

        if (null === e || undefined === e) {
            day[property] = undefined;
        }
        else {
            day[property] = e.split("T")[0];
        }

        this.setState({
            day: day
        });
    }

    onSelectValue(e, property) {
        const { day } = this.state;

        day[property] = e;

        this.setState({
            day: day
        });
    }

    onSave() {
        if (this.validInput()) {
            const { day } = this.state;
            this.props.onSave(day);
        }
    }

    validInput() {
        let errors = 0;
        let dateInputError = null;
        let dayTypeInputError = null;

        const { day } = this.state;

        if ("" === day.date || null === day.date || undefined === day.date) {
            dateInputError = 'error';
            errors++;
        }

        if (null === day.dayType || undefined === day.dayType) {
            dayTypeInputError = 'error';
            errors++;
        }

        this.setState({
            dateInputError: dateInputError,
            dayTypeInputError: dayTypeInputError,
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { day, dateInputError, dayTypeInputError } = this.state;

        if (undefined === day || null === day) {
            return null;
        }

        const { title, dayTypes } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formBeginDate" validationState={dateInputError}>
                            <ControlLabel>Data</ControlLabel>
                            <DatePicker
                                id="datePicker"
                                dateFormat="YYYY/MM/DD"
                                value={day.date}
                                placeholder="Introduza a Data"
                                onChange={(e) => this.onChangeDateValue(e, 'date')} />

                            {dateInputError !== null ?
                                <HelpBlock> Valor de data inválido. Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formDayType" validationState={dayTypeInputError}>
                            <ControlLabel>Tipo de Dia</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Tipo de Dia"
                                noOptionsMessage={() => "Sem Tipos de Dia Configurados"}
                                onChange={(e) => this.onSelectValue(e, "dayType")}
                                options={dayTypes}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== day.dayType && undefined !== day.dayType) {
                                        return day.dayType.id === a.id;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={day.dayType}
                            />
                            {dayTypeInputError !== null ?
                                <HelpBlock> Tipo de Dia inválido.</HelpBlock> :
                                null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/calendar/days/DayForm.js